<template>
  <div :class="classnames">
    <slot />
  </div>
</template>

<script>
  import { bem } from '@/mixins/bem.js'

  const namespace = 'tabs'

  export default {
    name: 'Tabs',
    mixins: [ bem ],
    props: {
      focusedTab: {
        default: 0,
        type: Number
      }
    },
    data: function () {
      const id = this.focusedTab

      return {
        focusedTabId: id
      }
    },
    created: function () {
      this.namespace = namespace
    },
    mounted: function () {
      this.initialize()
    },
    watch: {
      focusedTabId: function () {
        this.$emit('focus', this.focusedTabId)
      }
    },
    methods: {
      handleNavClick: function () {
        const self = this

        this.$children.forEach(function ($child) {
          const isTabsNav = $child.$vnode.componentOptions.tag === 'tabs-nav'

          if (isTabsNav) {
            $child.$on('click', function (id) {
              self.setFocusedTabId(id)
            })
          }
        })
      },
      initialize: function () {
        this.handleNavClick()

        this.setInitialTabFocus()
      },
      setFocusedTabId: function (id) {
        this.focusedTabId = id
      },
      setInitialTabFocus: function () {
        this.$emit('focus', this.focusedTabId)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/components/Tabs/Tabs.vue